import React, { useContext, useEffect, useRef, useState } from 'react';
import { ToastContext } from 'app/context/ToastContext';
import { Divider } from 'primereact/divider';
import './contract-page.css';
import axios from 'axios';
import { formatDateFromInstant } from 'app/shared/util/date-utils';
import { InputTextarea } from 'primereact/inputtextarea';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'reactstrap';

export const ClientMessagePage = () => {
  const { showSuccess, showError } = useContext(ToastContext);
  const [data, setData] = useState([]);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [files, setFiles] = useState([]);
  const fileUploadRef = useRef(null);

  useEffect(() => {
    // Example GET request; adjust URL & structure as needed
    axios
      .get('/api/client-request-message/messages')
      .then(response => {
        setData(response.data);
      })
      .catch(error => {
        console.error('Error fetching sent requests:', error);
        showError('Chyba', error.response?.data?.detail);
      });
  }, []);

  const handleSelect = e => {
    // e.files is an array of the newly selected files.
    // If you want to allow multiple selections across multiple picks,
    // you might combine them with existing files in state.
    setFiles(prev => [...prev, ...e.files]);
  };

  const handleSubmit = () => {
    const formData = new FormData();

    formData.append('message', message);

    // Append each selected file to formData
    files.forEach(file => {
      formData.append('attachments', file);
    });

    axios
      .post('/api/client-request-message/sendMessage', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(r => {
        setMessage('');
        setFiles([]);
        if (fileUploadRef.current) {
          fileUploadRef.current.clear();
        }
        setData(r.data);
        showSuccess('Úspech', 'Správa bola úspešne odoslaná.');
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      });
  };

  const downloadDocument = async contractDocument => {
    const response = await axios.get(`/api/client-request-message/download/${contractDocument.id}`, {
      responseType: 'blob', // Important for binary data
    });

    // Create a URL for the blob
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', contractDocument.originalFilename); // Set the original file name
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const onDownload = rowData => {
    downloadDocument(rowData);
  };

  return (
    <div>
      <h1 style={{ color: 'var(--primary-color)' }}>SPRÁVY</h1>

      <Divider className="client-divider" />

      <div className="new-request-container" style={{ borderColor: '#b9985a !important' }}>
        <div className="p-3">
          {data?.length > 0 ? (
            data.map((req, index) => (
              <div
                key={index}
                className="border mb-3 p-3"
                style={{
                  borderColor: 'var(--primary-color)',
                  backgroundColor: req.isAdminMessage ? 'rgba(238,189,83,0.8)' : 'rgba(243,232,207,0.8)',
                  justifyContent: 'center',
                  marginLeft: req.isAdminMessage ? '3rem' : '0rem',
                  marginRight: req.isAdminMessage ? '0rem' : '3rem',
                }}
              >
                {/* Display whatever data you like here, e.g. a message: */}
                <div
                  style={{
                    color: '#666',
                  }}
                >
                  <div>
                    <b>{req.isAdminMessage ? 'Odpoveď od NFA' : 'Správa od Vás'}</b>
                  </div>
                  <p>{req.text}</p>
                  {req.documents && req.documents.length > 0 && (
                    <div className="message-attachments">
                      {req.documents.map(attachment => (
                        <a key={attachment.id} onClick={() => onDownload(attachment)} download className="attachment-link">
                          {attachment.originalFilename}
                        </a>
                      ))}
                    </div>
                  )}
                  <div className="message-timestamp">{formatDateFromInstant(req.createdDate)}</div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-muted">Žiadne odoslané alebo prijaté správy.</p>
          )}
        </div>
      </div>

      <div className="border new-request-container" style={{ borderColor: 'var(--primary-color)' }}>
        {/* Box heading in gold background */}
        <div style={{ backgroundColor: 'var(--primary-color)', padding: '0.5rem' }}>
          <h5 className="mb-0 text-white">NOVÁ SPRÁVA</h5>
        </div>

        {/* Text area for the request message */}
        <div className="p-3">
          <InputTextarea
            rows={5}
            autoResize
            style={{ width: '100%' }}
            placeholder="Sem napíšte sprievodný text"
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
        </div>

        {/* File uploader & Submit buttons */}
        <div className="px-3 pb-3">
          {/* Multiple file upload with "Pridať prílohu" */}
          <FileUpload
            ref={fileUploadRef}
            name="attachments"
            multiple
            accept=".csv,.xml,.pdf,.xlsx,.png,.jpg,.jpeg,.doc,.docx,.xls,.ppt,.pptx,.txt,.odt,.ods,.odp,.ics"
            mode="advanced"
            customUpload
            auto={false} // don't auto-upload
            chooseLabel="Pridať prílohu"
            cancelLabel="Zrušiť"
            uploadLabel={null}
            onSelect={handleSelect}
            chooseOptions={{ icon: 'pi pi-paperclip' }}
          />

          {/* Submit button */}
          <div className="flex mt-2" style={{ justifyContent: 'end' }}>
            <Button
              className="p-button-primary ms-2"
              style={{ paddingLeft: '2rem', paddingRight: '2rem' }}
              icon="pi pi-check"
              onClick={handleSubmit}
            >
              Odoslať
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientMessagePage;
